import { createSlice } from '@reduxjs/toolkit'
import { initialTeamChatbotState } from '../initialState/teamChatbot'
import {
  fetchTeamChatbotsByTeam,
  fetchTeamChatbotsByRoom,
  createNewTeamChatbot,
  updateExistingTeamChatbot,
  deleteExistingTeamChatbot,
} from '../asyncThunks/teamChatbot'

const teamChatbotSlice = createSlice({
  name: 'teamChatbot',
  initialState: initialTeamChatbotState,
  reducers: {
    clearTeamChatbots: (state) => {
      state.teamChatbots = []
      state.error = null
    },
    clearError: (state) => {
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch team chatbots by team
      .addCase(fetchTeamChatbotsByTeam.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchTeamChatbotsByTeam.fulfilled, (state, action) => {
        state.isLoading = false
        state.teamChatbots = action.payload
        state.error = null
      })
      .addCase(fetchTeamChatbotsByTeam.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Fetch team chatbots by room
      .addCase(fetchTeamChatbotsByRoom.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(fetchTeamChatbotsByRoom.fulfilled, (state, action) => {
        state.isLoading = false
        state.teamChatbots = action.payload
        state.error = null
      })
      .addCase(fetchTeamChatbotsByRoom.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Create team chatbot
      .addCase(createNewTeamChatbot.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(createNewTeamChatbot.fulfilled, (state, action) => {
        state.isLoading = false
        state.teamChatbots.push(action.payload)
        state.error = null
      })
      .addCase(createNewTeamChatbot.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Update team chatbot
      .addCase(updateExistingTeamChatbot.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(updateExistingTeamChatbot.fulfilled, (state, action) => {
        state.isLoading = false
        const index = state.teamChatbots.findIndex(
          (tc) => tc.id === action.payload.id
        )
        if (index !== -1) {
          state.teamChatbots[index] = action.payload
        }
        state.error = null
      })
      .addCase(updateExistingTeamChatbot.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
      // Delete team chatbot
      .addCase(deleteExistingTeamChatbot.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(deleteExistingTeamChatbot.fulfilled, (state, action) => {
        state.isLoading = false
        state.teamChatbots = state.teamChatbots.filter(
          (tc) => tc.id !== action.payload
        )
        state.error = null
      })
      .addCase(deleteExistingTeamChatbot.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload as string
      })
  },
})

export const { clearTeamChatbots, clearError } = teamChatbotSlice.actions
export default teamChatbotSlice.reducer
